import type { SVGProps } from 'react';
const SvgVerticalAlignBottom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#vertical_align_bottom_svg__a)">
      <path
        fill="currentColor"
        d="M16 13h-3V3h-2v10H8l4 4 4-4ZM4 19v2h16v-2H4Z"
      />
    </g>
    <defs>
      <clipPath id="vertical_align_bottom_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgVerticalAlignBottom;
